/* eslint-disable */
import { FormEditFieldCreateDialogView, FormEditFieldDialogViewFactory, FormEditFieldUpdateDialogView, } from './form-utils';
import { ComponentFactoryResolver, ComponentRef, Injector, } from '@angular/core';
/* eslint-disable */
import { FormEditCreateUpdateReadonlyPictureFieldDialogComponent } from '../../admin/form/form-edit/dialogs/fields/readonly/picture-create-update/form-edit-create-update-readonly-picture-field-dialog.component';
/* eslint-enable */

/* eslint-enable */

/**
 * ReadonlyText field implementation.
 */
export class FormEditReadonlyPictureFieldDialogViewFactory implements FormEditFieldDialogViewFactory {

  constructor(private injector: Injector,
              private cfr: ComponentFactoryResolver) {
  }

  createCreateView(): ComponentRef<FormEditFieldCreateDialogView> {
    return this.createView();
  }

  createUpdateView(): ComponentRef<FormEditFieldUpdateDialogView> {
    return this.createView();
  }

  private createView(): ComponentRef<FormEditCreateUpdateReadonlyPictureFieldDialogComponent> {
    return this.cfr.resolveComponentFactory(FormEditCreateUpdateReadonlyPictureFieldDialogComponent)
      .create(this.injector);
  }

}
